import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=ddb32f7a&scoped=true&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"
import style0 from "./Paper.vue?vue&type=style&index=0&id=ddb32f7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb32f7a",
  null
  
)

export default component.exports